<template>
  <div>
    <div class="">
      <div class="tw-flex md:tw-items-center tw-gap-2 tw-flex-col md:tw-flex-row tw-grid-cols-1">
        <div class="tw-grid tw-grid-cols-2 tw-gap-2 tw-w-full">
          <div>
            <FormField
              v-model="variant.variant_name"
              :label="$t('fields.variant_name')"
              :error="errors.variant_name && $t('errors.' + errors.variant_name, { field: $t('fields.variant_name') })"
              type="text"
              class=""
            />
          </div>
          <div>
            <FormField
              v-model.number="variant.quantity"
              input-dir="ltr"
              :label="$t('fields.quantity')"
              :error="errors.quantity && $t('errors.' + errors.quantity, { field: $t('fields.quantity') })"
              type="number"
              class=""
            />
          </div>
        </div>
        <a-button @click="handleAdd" intent="simple" left-icon="heroicons:plus-16-solid" class="tw-px-2 tw-w-fit">{{ $t("buttons.add") }}</a-button>
      </div>
    </div>
    
    <div class="tw-mt-1 tw-overflow-hidden">
      <div v-if="!variants.length" class="tw-col-span-12 md:tw-col-span-6 tw-p-5 tw-bg-neutral-100 tw-text-gray-500 tw-text-center tw-rounded">
        {{ $t('common.no_variants') }}
      </div>

      <div v-else class="tw-col-span-12 md:tw-col-span-6">
        <SourcingVariantsTable @delete="handleDelete" :variants="variants" />
      </div>
    </div>
  </div>
</template>

<script setup>
import FormField from "@/components/form/FormField";
import SourcingVariantsTable from './SourcingVariantsTable.vue';
import { ref, toRef, defineProps, defineEmits } from 'vue';

const props = defineProps(['variants']);
const emit = defineEmits(['update:variants']);
const variants = toRef(props, 'variants');

const variant = ref({});
const errors = ref({});

const handleAdd = () => {
  let valid = true;
  errors.value = {};

  if (!variant.value.variant_name) {
    errors.value.variant_name = 'required';
    valid = false;
  }

  if (!variant.value.quantity) {
    errors.value.quantity = 'required';
    valid = false;
  }

  if (!valid) return;

  variant.value.id = Date.now();
  variant.value.new = true;
  variants.value.push(variant.value);
  variant.value = {};
  emit('update:variants', variants.value);
};

const handleDelete = (index) => {
  variants.value.splice(index, 1);
  emit('update:variants', variants.value);
};
</script>

<style></style> 